export const EdgeSolutionsLayout = {
  slots: [
    'SlbEdgeSolutionsPdpSlot',
    'SlbBlueBottomBannerSlot'
  ],
};
